export enum PrepaymentTypeEnum {
    NO = 'no',
    FIXED = 'fixed',
    PERCENT = 'percent',
}
